import { useParams } from 'react-router-dom';
import { urlIdParamToId } from '@app/api/mappers';

export const useIdParam = (): string | undefined => {
  const { id: urlId } = useParams();
  return urlIdParamToId(urlId);
};
